var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12713_155323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.883659 19.1132C0.395628 18.6251 0.395628 17.8339 0.883659 17.3458L17.3459 0.883565C17.834 0.395533 18.6252 0.395532 19.1132 0.883564C19.6013 1.3716 19.6013 2.16285 19.1132 2.65088L2.65098 19.1132C2.16295 19.6012 1.37169 19.6012 0.883659 19.1132Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8812 19.1132C15.3932 18.6251 15.3932 17.8339 15.8812 17.3458L17.3458 15.8812C17.8339 15.3932 18.6251 15.3932 19.1131 15.8812C19.6012 16.3693 19.6012 17.1605 19.1131 17.6485L17.6485 19.1132C17.1605 19.6012 16.3692 19.6012 15.8812 19.1132Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38268 19.1132C7.89465 18.6251 7.89465 17.8339 8.38268 17.3458L17.3461 8.38242C17.8341 7.89439 18.6254 7.89439 19.1134 8.38242C19.6014 8.87045 19.6014 9.66171 19.1134 10.1497L10.15 19.1132C9.66197 19.6012 8.87071 19.6012 8.38268 19.1132Z",
    fill: "#A3A3A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12713_155323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeIcon);
export default __webpack_public_path__ + "static/media/resizeIcon.46ca1b9dcee3a58eb87ad8965b1a7d3b.svg";
export { ForwardRef as ReactComponent };